import { render } from "./TreeSetting.vue?vue&type=template&id=40d8241b&scoped=true"
import script from "./TreeSetting.vue?vue&type=script&lang=js"
export * from "./TreeSetting.vue?vue&type=script&lang=js"

import "./TreeSetting.vue?vue&type=style&index=0&id=40d8241b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d8241b"]])

export default __exports__